import Navbar from "./Navbar";
import Carousel from "./Carousel";
import Description from "./Description";
import PriceAndCart from "./PriceAndCart";
import { useState } from "react";

function App() {
    const [quantity, setQuantity] = useState(0);

    function handleQuantity(number) {
        setQuantity(number);
    }
    return (
        <div>
            <Navbar quantity={quantity} handleQuantity={handleQuantity} />
            <Carousel />
            <Description />
            <PriceAndCart handleQuantity={handleQuantity} />
        </div>
    );
}

export default App;
